import { NEUTRAL_FONT_STACK, NEUTRAL_STYLESHEET_HEAD } from './palette'
import { focusOutlineRules, inputRules, primaryButtonRules } from './neutralFragments'

export const NEUTRAL_AUTH_CSS = `
${NEUTRAL_STYLESHEET_HEAD}
.na-root, .na-root *, .na-root *::before, .na-root *::after { box-sizing: border-box; }
.na-root {
  min-height: 100vh;
  display: flex;
  background: var(--na-page-bg);
  color-scheme: var(--na-scheme);
  font-family: ${NEUTRAL_FONT_STACK};
  color: var(--na-ink);
  -webkit-font-smoothing: antialiased;
}
.na-left {
  flex: 1 1 58%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 16px 0 16px 16px;
  padding: 40px 64px 56px;
  border-radius: 24px;
  background: var(--na-panel-bg);
}
.na-brand, .na-mobile-brand {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: var(--na-brand-ink);
  position: relative;
  z-index: 1;
}
.na-hero {
  position: relative;
  z-index: 1;
  margin: auto 0;
  padding-top: 48px;
  max-width: 540px;
}
.na-headline {
  margin: 0 0 20px;
  font-size: 52px;
  line-height: 1.08;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: var(--na-ink);
}
.na-headline span { color: var(--na-link); }
.na-lede {
  margin: 0 0 40px;
  max-width: 440px;
  font-size: 18px;
  line-height: 1.55;
  color: var(--na-muted);
}
.na-features {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.na-features li { display: flex; gap: 16px; align-items: flex-start; }
.na-feature-icon {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--na-icon-bg);
  color: var(--na-icon);
  display: flex;
  align-items: center;
  justify-content: center;
}
.na-feature-title { margin: 2px 0 4px; font-size: 16px; font-weight: 600; color: var(--na-ink); }
.na-feature-text { margin: 0; max-width: 330px; font-size: 14px; line-height: 1.5; color: var(--na-muted); text-wrap: pretty; }
.na-decor { position: absolute; inset: 0; pointer-events: none; }
.na-orb { position: absolute; border-radius: 50%; }
.na-orb-1 {
  width: 440px;
  height: 440px;
  right: -140px;
  bottom: -160px;
  background: radial-gradient(circle at 35% 35%, var(--na-orb-1), transparent 70%);
}
.na-orb-2 {
  width: 300px;
  height: 300px;
  right: 60px;
  top: -110px;
  background: radial-gradient(circle, var(--na-orb-2), transparent 70%);
}
.na-panel {
  position: absolute;
  right: -90px;
  top: 24%;
  width: 34%;
  height: 52%;
  border-radius: 32px;
  background: var(--na-glass);
  border: 1px solid var(--na-glass-border);
  box-shadow: var(--na-glass-shadow);
  transform: rotate(-6deg);
}
.na-right {
  flex: 0 0 min(580px, 44%);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 88px 40px 48px;
}
.na-mobile-brand { display: none; }
.na-assurance {
  position: absolute;
  top: 66px;
  right: 48px;
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--na-muted);
}
.na-card {
  width: 100%;
  max-width: 440px;
  padding: 44px 40px 40px;
  background: var(--na-card);
  border: 1px solid var(--na-card-border);
  border-radius: 18px;
  box-shadow: var(--na-card-shadow);
}
.na-card-title { margin: 0 0 8px; font-size: 28px; font-weight: 600; text-align: center; color: var(--na-ink); }
.na-card-sub { margin: 0 0 32px; font-size: 16px; text-align: center; color: var(--na-muted); }
.na-field { margin-bottom: 20px; }
.na-label { display: block; margin-bottom: 8px; font-size: 14px; font-weight: 600; color: var(--na-ink); }
.na-input-wrap { position: relative; }
.na-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  color: var(--na-muted);
  pointer-events: none;
}
${inputRules('.na-input', { paddingLeft: 46, paddingRight: 52 })}
.na-eye {
  position: absolute;
  right: 3px;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: var(--na-muted);
  cursor: pointer;
}
.na-eye:hover { color: var(--na-ink); }
${focusOutlineRules('.na-eye')}
.na-forgot { margin: -6px 0 24px; text-align: right; }
.na-forgot a {
  color: var(--na-link);
  font-size: 14px;
  font-weight: 500;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.na-forgot a:hover { color: var(--na-link-hover); }
${focusOutlineRules('.na-forgot a')}
${primaryButtonRules('.na-submit')}
@media (max-width: 1200px) {
  .na-left { padding: 40px 44px 48px; }
  .na-headline { font-size: 44px; }
}
@media (max-width: 1024px) {
  .na-root { flex-direction: column; }
  .na-left { display: none; }
  .na-right { flex: 1 1 auto; justify-content: flex-start; padding: 32px 16px 40px; }
  .na-mobile-brand { display: flex; margin-bottom: 12px; }
  .na-assurance { position: static; margin: 0 0 24px; font-size: 12px; letter-spacing: 0.14em; text-align: center; }
  .na-card { padding: 32px 22px 28px; }
  .na-card-title { font-size: 24px; }
}
`
